<script>
import MobilePage from '@/components/app/mobile/Page'
import DesktopPage from '@/components/app/desktop/Page'

export default {
  components: { MobilePage, DesktopPage },
}
</script>

<template>
	<div class="antialiased overflow-hidden">
		<MobilePage class="lg:hidden" />
		<DesktopPage class="hidden lg:flex" />
	</div>
</template>

<style>
@media (min-width: 1024px) {
	header {
		position: relative;
		background: #F4F3EF;
	}
}

footer {
	display: none;
}
</style>
